import { Phone, MessageCircle, Sparkles } from "lucide-react";
import { COMPANY, telLink, buildWhatsAppLink } from "../lib/site";
import { motion } from "framer-motion";

export default function StickyButtons({ onOpenLead }) {
  return (
    <>
      {/* WhatsApp - bottom right */}
      <motion.a
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.2 }}
        href={buildWhatsAppLink()}
        target="_blank"
        rel="noreferrer"
        data-testid="sticky-whatsapp"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_0_30px_rgba(37,211,102,0.45)] hover:scale-110 transition-transform duration-300"
      >
        <MessageCircle className="w-6 h-6 text-white" strokeWidth={1.8} />
        <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-white animate-ping" />
      </motion.a>

      {/* Call - bottom left */}
      <motion.a
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.4 }}
        href={telLink(COMPANY.phones[1])}
        data-testid="sticky-call"
        aria-label="Call us now"
        className="fixed bottom-6 left-6 z-40 w-14 h-14 rounded-full bg-[#D4AF37] flex items-center justify-center shadow-[0_0_30px_rgba(212,175,55,0.4)] hover:scale-110 transition-transform duration-300"
      >
        <Phone className="w-6 h-6 text-black" strokeWidth={1.8} />
      </motion.a>

      {/* Floating Inquiry - bottom right above whatsapp on lg */}
      <motion.button
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.6 }}
        onClick={onOpenLead}
        data-testid="sticky-enquire"
        aria-label="Book a free site visit"
        className="fixed bottom-24 right-6 z-40 hidden md:flex items-center gap-2 px-5 py-3 bg-black/60 backdrop-blur-xl border border-[#D4AF37]/40 text-[#D4AF37] text-xs tracking-[0.2em] uppercase hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
      >
        <Sparkles className="w-4 h-4" strokeWidth={1.4} />
        Book Site Visit
      </motion.button>
    </>
  );
}
